import restCrudReducer from '../../../np-crud/store/restCrudReducer';
import * as actions from './actionTypes';

const [crudInitialState, crudReducer] = restCrudReducer({
    pluginName: 'BILLING',
    entityName: 'DELIVERY_NOTE',
});

const initialState = {
    ...crudInitialState,
    charging: false,
    charged: null,
    deleting: false,
    saving: false
};

const reducer = (state = initialState, action) => {
    // Handle CRUD actions
    const newState = crudReducer(state, action);
    // If CRUD reducer handled the action
    if (newState !== null) {
        return newState;
    }

    // Handle other actions
    switch (action.type) {
        case 'CORE|LOGOUT_SUCCESS':
        case 'CORE|CORE_SET_ACTIVE_CUSTOMER_SUCCESS':
            return initialState;
        case actions.CHARGING_DELIVERY_NOTE_START:
            return {...state, charging: true};
        case actions.CHARGING_DELIVERY_NOTE_FAIL:
            return {...state, charging: false};
        case actions.CHARGING_DELIVERY_NOTE_SUCCESS:
            return {...state, charging: false, charged: action.charged};
        default:
            return state;
    }
};

export default reducer;
